/**
 * Smooth Interactive Intersection Observer Engine & Mechanical Flip State Toggles
 */
document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('.prod-features-section');
  
  sections.forEach(section => {
    const heading = section.querySelector('.prod-features-heading');
    const cards = section.querySelectorAll('.prod-features-card');

    // 1. Initial Scroll Reveal Observation Engine Setup
    const revealOptions = {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.01
    };

    const scrollObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (entry.target.classList.contains('prod-features-heading')) {
            entry.target.classList.add('is-visible');
          } else if (entry.target.classList.contains('prod-features-card')) {
            const cardArray = Array.from(cards);
            const cardIndex = cardArray.indexOf(entry.target);
            
            setTimeout(() => {
              entry.target.classList.add('is-visible');
            }, cardIndex * 70); 
          }
          scrollObserver.unobserve(entry.target);
        }
      });
    }, revealOptions);

    if (heading) scrollObserver.observe(heading);
    cards.forEach(card => scrollObserver.observe(card));

    // 2. Click Mechanical Toggle Actions
    cards.forEach(card => {
      const returnBtn = card.querySelector('.back-card-return-trigger');
      
      // Front card click panel action wrapper
      card.addEventListener('click', function (e) {
        // Safe check block loops to prevent clashes with actual collection anchors redirects
        if (e.target.closest('.prod-features-collection-link')) return;

        // If card already has the active flip class status tracker active, skip forward action overrides
        if (card.classList.contains('is-flipped')) return;

        card.classList.add('is-flipped');
      });

      // BACK TO FRONT: Reverse Mechanical Click Handler Functionality Setup Blocks
      if (returnBtn) {
        returnBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation(); // Stops parent container click triggers from executing twice
          card.classList.remove('is-flipped');
        });
      }
      
      // Auto flip layout cards clean down to front faces on mouse space departures across screens
      card.addEventListener('mouseleave', function () {
        card.classList.remove('is-flipped');
      });
    });
  });
});